// API Endpoints
export const API_ENDPOINTS = {
  CUSTOMIZATIONS: '/customizations',
  OPTIONS: '/options',
  CATEGORIES: '/categories',
  CATEGORY_ITEMS: (categoryId: number) => `/categories/${categoryId}/items`,
  CUSTOMIZATION_STOCK_TOGGLE: (customizationId: number) => `/customizations/stock-toggle?customization=${customizationId}`,
  CLONE_CUSTOMIZATION: '/customizations/clone',
} as const;

// View Names
export const VIEWS = {
  ADD: 'add',
  OPTIONS: 'options',
  ADD_ITEMS: 'addItems',
  CUSTOMIZATION_RULES: 'customizationRules',
  EDIT_OPTION: 'editOption',
  EDIT_SIDE_BOX: 'editSideBox',
} as const;

// Submission Types
export const SUBMISSION_TYPES = {
  NAME: 'name',
  OPTIONS: 'options',
  ADD_TO_ITEMS: 'addtoitems',
  CUSTOMIZATION_RULES: 'customizationrules',
  CREATE: 'create',
} as const;

// Toast Durations
export const TOAST_DURATIONS = {
  SHORT: 3000,
  MEDIUM: 5000,
  LONG: 7000,
  VERY_LONG: 9000,
} as const;

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  ITEMS_PER_PAGE: 50,
} as const;

// Default Values
export const DEFAULT_VALUES = {
  SEQUENCE_NUMBER: 0,
  MIN_QUANTITY: 0,
  MAX_QUANTITY: 0,
  MULTIPLE_SELECTIONS_QUANTITY: 0,
  PRICE: 0,
  SOLD_OUT: false,
  MULTIPLE_SELECTIONS: false,
} as const;

// Event Names
export const CUSTOM_EVENTS = {
  CUSTOMIZATION_UPDATED: 'customizationUpdated',
  CUSTOMIZATION_CREATED: 'customizationCreated',
  CUSTOMIZATION_DELETED: 'customizationDeleted',
  OPTIONS_REORDERED: 'optionsReordered',
  OPTION_ADDED: 'optionAdded',
} as const;

// Modal Sizes
export const MODAL_SIZES = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  XL: 'xl',
  FULL: 'full',
} as const;

// Placeholder Images
export const PLACEHOLDER_IMAGES = {
  ITEM: 'https://via.placeholder.com/50',
} as const;

// Tab Index
export const TAB_INDEX = {
  CUSTOMIZATIONS: 5,
} as const;

// Common Messages
export const MESSAGES = {
  LOADING_CATEGORIES: 'Loading categories...',
  LOADING_ITEMS: 'Loading items...',
  NO_CATEGORIES_FOUND: 'No categories found',
  NO_ITEMS_FOUND: 'No items found in this category',
  NO_CATEGORIES_AVAILABLE: 'No categories available',
  NO_CATEGORIES_MATCHING_SEARCH: 'No categories found matching your search',
  CUSTOMIZATION_NAME_REQUIRED: 'Customization name is required.',
  CUSTOMIZATION_NAME_CANNOT_BE_EMPTY: 'Customization name cannot be empty.',
  CUSTOMIZATION_CREATED_SUCCESS: 'Customization created successfully!',
  CUSTOMIZATION_UPDATED_SUCCESS: 'Customization updated successfully.',
  CUSTOMIZATION_DELETED_SUCCESS: 'Customization deleted successfully.',
  OPTIONS_UPDATED_SUCCESS: 'Options updated successfully.',
  ITEMS_UPDATED_SUCCESS: 'Items updated successfully.',
  RULES_UPDATED_SUCCESS: 'Rules updated successfully.',
  OPTION_CREATED_SUCCESS: 'Option created successfully.',
  OPTION_UPDATED_SUCCESS: 'Option updated successfully.',
  OPTION_REMOVED_SUCCESS: 'Option removed successfully.',
  STOCK_STATUS_UPDATED: 'Stock status updated',
  FAILED_TO_CREATE: 'Failed to create customization.',
  FAILED_TO_UPDATE: 'Failed to update customization.',
  FAILED_TO_DELETE: 'Failed to delete customization.',
  FAILED_TO_UPDATE_OPTION: 'Failed to update option.',
  FAILED_TO_SAVE_OPTION: 'Unable to save the option.',
} as const;

// Validation Messages
export const VALIDATION_MESSAGES = {
  MISSING_REQUIRED_FIELDS: 'Missing Required Fields',
  PLEASE_FILL_REQUIRED_FIELDS: 'Please fill out the following required fields:',
  OPTION_NAME: 'Option Name',
  PRICE: 'Price',
  CUSTOMIZATION_ID: 'Customization ID',
} as const;

// Common Styles
export const COMMON_STYLES = {
  CARD_PADDING: '16px',
  BORDER_RADIUS: '8px',
  MODAL_WIDTH: 800,
  MODAL_TOP: 20,
  MODAL_Z_INDEX: 2000,
  HEIGHT_CALC: 'calc(100vh - 120px)',
  MAX_HEIGHT_CALC: 'calc(100vh - 450px)',
} as const;

// Colors
export const COLORS = {
  PRIMARY: '#2D6CCA',
  DANGER: '#f5222d',
  SUCCESS: '#52c41a',
  WARNING: '#faad14',
  BLACK: '#000000',
  WHITE: '#ffffff',
  GRAY_LIGHT: '#f0f0f0',
  GRAY_MEDIUM: '#8c8c8c',
  GRAY_DARK: '#434343',
  BORDER_LIGHT: '#e8e8e8',
  BORDER_DARK: '#434343',
} as const;

